<script lang="ts" setup>
import { _postSavePPT, _putTrashById } from "@/api";
import { initPage, PPTList, usePPTList } from "./use/data";
import { step } from "../slidePPT/use/data";

const router = useRouter();
const { getPPTList } = usePPTList();

const themeInput = ref();
const titleInputRef = ref();

const showGoRecycleDialog = ref(false);
const curIndex = ref();

onActivated(() => {
  initPage();
  getPPTList();
});

const generateTheme = () => {
  if (!themeInput.value) {
    ElMessage.warning("请输入主题");
    return;
  }
  router.push({
    path: "/slidePPT",
    query: { theme: themeInput.value },
  });
  step.value = "theme";
  themeInput.value = null;
};

const handleEdit = (index: number) => {
  const item = PPTList[index];
  item.isEdit = true;
  nextTick(() => {
    if (titleInputRef.value && titleInputRef.value.input) {
      titleInputRef.value.input.focus();
    }
  });
};
const saveTitle = async (index: number) => {
  PPTList[index].isEdit = false;
  await _postSavePPT(PPTList[index].serial_no, {
    cover_url: PPTList[index].cover_url,
    name: PPTList[index].name,
    ppt_json: PPTList[index].ppt_json,
  });
};

const handleRecycle = (index: number) => {
  showGoRecycleDialog.value = true;
  curIndex.value = index;
};
const goRecycle = async () => {
  const res: any = await _putTrashById(PPTList[curIndex.value].serial_no);
  if (!res.serial_no) return;
  showGoRecycleDialog.value = false;
  ElMessage.success("已移入回收站");
  PPTList.splice(curIndex.value, 1);
};
</script>

<template>
  <div
    relative
    full
    p-30px
    overflow="y-scroll"
    v-infinite-scroll="getPPTList"
    infinite-scroll-distance="100"
  >
    <div class="main">
      <h3 mb-20px>快速创建</h3>
      <div w-full mb-20px flex gap-20px>
        <div
          px-20px
          w-358px
          h-142px
          rounded-10
          flex
          flex-col
          justify-center
          items-center
          text-14
          color-white
          style="background: linear-gradient(180deg, #4ce5fc 0%, #4ca7fc 100%)"
        >
          <div font-bold mb-16px>AI一键生成PPT</div>
          <div
            w-full
            h-50px
            flex
            justify-between
            items-center
            bg-white
            rounded-20
          >
            <el-input
              v-model="themeInput"
              placeholder="输入你要写的PPT主题内容"
            ></el-input>
            <div
              w-120px
              h-30px
              py-8px
              ml-20px
              mr-8px
              text-center
              rounded-16
              style="background-color: #333"
              cursor-pointer
              @click="generateTheme"
            >
              生成
            </div>
          </div>
        </div>

        <!--  @click="linkUpload" -->
        <div
          px-20px
          w-358px
          h-142px
          rounded-10
          flex
          flex-col
          justify-center
          items-center
          border="1px dashed #4C83FC"
          cursor-pointer
          @click="
            router.push({
              path: '/slidePPT',
              query: {
                type: 'upload',
              },
            })
          "
        >
          <!-- <el-upload
            action="#"
            accept=".docx"
            :show-file-list="false"
            :before-upload="beforeUpload"
            :http-request="overwriteNativeAjax"
          >
            <div class="flex-center flex-col">
              <CsdImg src="/images/aiDoc/upload-doc-icon.svg" />
              <div class="text-center my-8 text-#333333">上传文档</div>
              <div class="color-#999999 text-12 text-center leading-16">
                仅支持docx文件格式丨文档限制最大5M；
                <br />*建议选择4500字以内的 word 文档，超过长度将自动截断
              </div>
            </div>
          </el-upload> -->
          <CsdImg src="/images/aiDoc/upload-doc-icon.svg" />
          <div mt-16px>上传文档</div>
        </div>
      </div>
    </div>

    <div class="main">
      <div flex justify-between>
        <h3 mb-20px>我的作品</h3>
        <div
          flex
          items-center
          py-8px
          px-20px
          rounded-20
          cursor-pointer
          style="background-color: #f1f1f1"
          @click="router.push('/recycle')"
        >
          <span class="iconfont ppt-delete"></span> <span ml-4px>回收站</span>
        </div>
      </div>
      <PPTListContainer full :PPTList="PPTList" v-slot="{ item, index }">
        <div class="menu-item">
          <span v-if="!item.isEdit" line-clamp-1>{{ item.name }}</span>
          <el-input
            v-if="item.isEdit"
            v-model="item.name"
            ref="titleInputRef"
            placeholder="请输入标题"
            autosize
            @keydown.enter="saveTitle(index)"
            @blur="saveTitle(index)"
          ></el-input>
          <span
            v-if="!item.isEdit"
            class="iconfont ppt-edit1"
            ml-14px
            cursor-pointer
            @click="handleEdit(index)"
          ></span>
        </div>
        <div class="menu-item" cursor-pointer @click="handleRecycle(index)">
          <div>
            <span class="iconfont ppt-delete"></span> <span>移入回收站</span>
          </div>
        </div>
      </PPTListContainer>
    </div>
    <ComDialog
      v-model:value="showGoRecycleDialog"
      title="移入回收站"
      desc="文档移入回收站，保留30天后将自动彻底删除"
      width="300"
      @ok="goRecycle"
    />
  </div>
</template>

<style lang="scss" scoped>
.menu-item {
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 54px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #f1f1f1;
  }
  &:last-child {
    border-bottom: 0px;
  }
}
</style>
